<ng-container *ngIf="dataSource?.CardData as ds">
    <article (click)="accommodation == 'ecolodge' ?  navigateToPDP(ds.HotelUrl, $event) : null"
        class="bg-white flex flex-col items-stretch rounded-lg border border-solid shadow-sm overflow-hidden"
        [class]="(dataSource?.Header && accommodation != 'ecolodge') ? 'light-blue-border' : ''"
        [ngClass]="accommodation != 'ecolodge' ? '' : 'h-[390px] cursor-pointer'">
        <ng-container *ngIf="accommodation != 'ecolodge'">
            <div *ngIf="dataSource?.Header as headerText"
                class="w-full px-4 py-2 items-center text-sm bg-blue-50 text-blue-500 border-bottom-0 top-corners-radius">
                {{ headerText }}
            </div>
        </ng-container>

        <div class="flex  md:items-stretch w-full relative overflow-hidden"
            [ngClass]="accommodation != 'ecolodge' ? 'flex-col md:flex-row' : 'flex-col'">
            <div class=" w-full  md:min-w-[250px] swiper-cards-search relative"
                [ngClass]="accommodation != 'ecolodge' ? 'md:w-[250px] h-56' : 'h-50'" *ngIf="ds.Pictures.length">
                <swiper (slideChange)="onSlideChange($event)" [config]="swiperConfig"
                    [ngClass]="accommodation != 'ecolodge' ? '!h-56 max-h-56 min-h-56' : '!h-[148px] max-h-[148px] min-h-[148px]'"
                    #swiper>

                    <ng-template swiperSlide
                        *ngFor="let item of filteredPictures(); let index = index; let first = first">
                        <img *ngIf="item.Jpg;else noImage" [src]="item.Jpg" [loading]="first ? 'eager' : 'lazy'"
                            (error)="item.Jpg  = cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover" height="230" width="250"
                            [alt]="item.Alt" />
                        <ng-template #noImage>
                            <img [src]="cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover" height="230"
                                width="250" [alt]="item.Alt" />
                        </ng-template>
                        

                    </ng-template>

                    <ng-template swiperSlide class="lg:hidden" *ngIf="accommodation != 'ecolodge'">
                        <button *ngIf="ds.Pictures.length > 3" (click)="navigateToPDP(ds.HotelUrl, $event)"
                            class="flex lg:hidden flex-col items-center justify-center h-[176px] w-full">
                            <i class="ico-LeftArrowCircle text-4xl text-blue"></i>
                            <span class="text-sm text-black font-semibold">مشاهده بیشتر</span>
                        </button>
                    </ng-template>

                </swiper>
                <div class="hover-swiper-button-prev-next">
                    <div class="swiper-button-prev flex" *ngIf="showArrowNext" (click)="nextSlide($event)">
                        <i class="ico-Left text-3xl"></i>
                    </div>
                    <div class="swiper-button-next flex" *ngIf="showArrowPrev" (click)="previousSlide($event)">
                        <i class="ico-Right text-3xl"></i>
                    </div>
                </div>


            </div>
            <div *ngIf="!ds.Pictures.length" class=" w-full  swiper-cards-search relative"
                [ngClass]="accommodation == 'ecolodge' ? '!h-[148px] max-h-[148px] min-h-[148px]' : 'md:w-[250px] md:min-w-[250px] min-w-[12rem] h-56'">
                <img [src]="cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover" height="230"
                    width="250" />
            </div>

            <!-- min-width of our card's image is 12rem + 1rem margin = 13rem -->

            <div class=" flex  items-stretch flex-grow justify-between"
                [ngClass]="accommodation != 'ecolodge' ? 'flex-col md:flex-row card-content-wrapper p-2 md:p-4' : 'flex-col p-2 h-[235px]'"
                (click)="navigatorVal ? navigateToPDP(ds.HotelUrl, $event) : {}">
                <!-- residence info section -->
                <div class="flex flex-col gap-2 md:border-left w-full pb-2 md:pb-0 md:pl-4  bordered-section flex-grow overflow-x-hidden"
                    [ngClass]="accommodation != 'ecolodge' ? 'md:w-3/5' : ''">
                    <ng-container *ngIf="accommodation == 'ecolodge';else noEcolodge">
                        <div class="flex gap-2 items-center ml-2 absolute top-[5px] right-[5px] z-10"
                            *ngIf="dataSource?.Labels?.Tags?.length">
                            <span *ngFor="let tag of dataSource?.Labels?.Tags"
                                class="px-2 py-1  text-sm whitespace-nowrap rounded-3xl bg-[#BBCFF9] text-primary-500">{{
                                tag.Title }}</span>
                        </div>

                        <!-- ihoplus tag -->
                        <img *ngIf="dataSource?.Labels?.IHOPlus"
                            ngSrc="assets/images/ihoplus.svg" 
                            class="bg-blue-50 rounded px-2 py-1 absolute mt-[-30px] right-[5px] z-10" height="17"
                            width="55" alt="IHO Plus logo">
                    </ng-container>
                    <ng-template #noEcolodge>
                        <div class="flex gap-2 items-center flex-wrap justify-self-start mb-1"
                            *ngIf="dataSource?.Labels?.Tags?.length || dataSource?.Labels?.IHOPlus">
                            <div class="flex gap-2 items-center ml-2"
                                *ngIf="dataSource?.Labels?.Tags?.length">
                                <span *ngFor="let tag of dataSource?.Labels?.Tags"
                                    class="px-2 py-1  text-sm whitespace-nowrap text-black-400 bg-black-50 rounded">{{
                                    tag.Title }}</span>
                            </div>

                            <!-- ihoplus tag -->
                            <img *ngIf="dataSource?.Labels?.IHOPlus"
                                ngSrc="assets/images/ihoplus.svg" class="bg-blue-50 rounded px-2 py-1" height="17"
                                width="55" alt="IHO Plus logo">
                        </div>
                    </ng-template>



                    <div class="flex gap-2 overflow-hidden max-w-full"
                        [ngClass]="accommodation == 'ecolodge' ? 'mb-0 h-[48px]' : 'mb-3'">
                        <img height="40" width="40" class="rounded-full border" alt="resident's owner avatar"
                            *ngIf="type !== 'hotel'" />
                        <!-- TODO: set titles and links -->
                        <a *ngIf="dataSource.Type != 2" [href]="ds.HotelUrl"
                            (click)="navigateToPDP(ds.HotelUrl, $event)">
                            <h2 class="text-black !font-semibold" [title]="ds.FullName"
                                [ngClass]="accommodation == 'ecolodge' ? 'text-base line-clamp-2' : 'text-xl'">
                                {{ ds.FullName }}
                            </h2>
                        </a>

                        <h2 class="text-black !font-semibold cursor-pointer" *ngIf="dataSource.Type == 2"
                            (click)="navigateToPDP(ds.HotelUrl, $event)"
                            [ngClass]="accommodation == 'ecolodge' ? 'text-base line-clamp-2' : 'text-xl'"
                            [title]="ds.FullName">
                            {{ ds.FullName }}
                        </h2>

                    </div>
                    <div class="flex flex-col">
                        <ng-container *ngIf="accommodation == 'ecolodge';else noneStar">
                            <div class="flex items-center gap-2" *ngIf="ds.detailsRoom">
                                <i class="ico-Profile-card-bold text-xl text-black-300"></i>
                                <span class="text-black-300 text-sm">{{ds.detailsRoom}}</span>
                            </div>
                        </ng-container>
                        <ng-template #noneStar>
                            <div class="flex items-center gap-2"
                                *ngIf="ds?.Star && type === 'hotel' && ds?.Star?.GradeId !== 0">
                                <i class="ico-Star-bold text-xl text-black-300"></i>
                                <span class="text-black-300 text-sm">{{ ds?.Star?.GradeId }} ستاره</span>
                            </div>
                        </ng-template>
                        <div class="flex items-center gap-2">
                            <i class="ico-Location-card-bold text-xl text-black-300"></i>
                            <span class="text-black-300 text-sm truncate"
                                *ngIf="accommodation == 'ecolodge';else noneEcolodge" [title]="ds?.Address?.Address">
                                {{
                                ds?.Address?.Address
                                }}</span>
                            <ng-template #noneEcolodge>
                                <span class="text-black-300 text-sm" [title]="ds?.Address?.Address">
                                    {{
                                    ds?.Address?.Address!.split('-')[0] +
                                    (ds?.Address?.Address!.split('-')[1] == undefined ? '' : ' - ' +
                                    ds?.Address?.Address!.split('-')[1])
                                    }}</span>
                            </ng-template>

                        </div>


                        <!-- rate and comments -->
                        <div class="flex items-center gap-2" *ngIf="ds?.Score?.Total! > 0">
                            <ng-container *ngIf="ds?.Score?.Total !== 0">
                                <p class="text-blue-500 flex items-center gap-2">
                                    <span class="h-7 w-7 text-center text-white text-base font-bold bg-blue-500"
                                        style="line-height: 1.75rem; border-radius: 4px">
                                        {{ ds?.Score?.ScoreNumber }}
                                    </span>
                                    <span class="score-text text-sm text-black-400"
                                        *ngIf="accommodation != 'ecolodge'">{{
                                        ds?.Score?.Text
                                        }}</span>
                                </p>
                            </ng-container>

                            <span class="text-sm text-muted font-semibold">{{
                                ds?.Score?.Total == 0 ? 'بدون نظر' : ds?.Score?.Total + ' نظر'
                                }}</span>
                        </div>

                        <ng-container *ngIf="dataSource.Labels?.Promotions">
                            <div class="bg-red-50 flex items-center justify-between w-full p-2 text-sm rounded-md overflow-hidden gap-3 lg:max-w-full"
                                *ngFor="let promotion of dataSource.Labels?.Promotions">
                                <em class="bg-white text-red-400 font-semi-bold px-2 py-1 whitespace-nowrap"
                                    style="font-style: normal; border-radius: 4px">
                                    {{ promotion.Title }}</em>
                                <div class="flex items-center gap-4">
                                    <iho-count-down *ngIf="promotion?.CountdownTimer"
                                        [dates]="promotion?.CountdownTimer" />
                                    <p class="text-black-400 ml-2 overflow-hidden text-xs">
                                        {{ promotion?.Description }}
                                    </p>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- promotions -->
                    <!-- dataSource?.Labels?.Promotions?.length -->
                    <div class="bg-red-50 flex items-center justify-between w-full p-2 text-sm rounded-md overflow-hidden"
                        *ngIf="false">
                        <em class="bg-white text-red-400 font-semibold px-2 py-1 whitespace-nowrap"
                            style="font-style: normal; border-radius: 4px">لحظه آخری</em>

                        <!-- TODO add timer component here -->
                        <p
                            class="text-black-400 ml-2 overflow-hidden whitespace-nowrap text-ellipsis md:max-w-[11rem] lg:max-w-[70%]">
                            {{dataSource?.Labels?.Promotions?.[0]?.Title}}
                        </p>
                    </div>
                </div>

                <!-- price and reserve button -->
                <div class="flex flex-col gap-2  md:pr-4 justify-end w-full"
                    [ngClass]="accommodation != 'ecolodge' ? 'md:w-2/5 md:h-full  md:max-w-[250px]' : ''">
                    <ng-container *ngIf="!dataSource?.FullCapacity; else fullCapacityBtn">
                        <div *ngIf="ds.Price?.OldPrice && ds.Price.IhoPrice"
                            class="flex w-full items-center justify-end gap-2">
                            <span *ngIf="ds.Price?.BoardPrice != ds.Price?.IhoPrice"
                                class="price-off mx-2 after:content-[''] line-through-price text-black-200 text-xs !font-normal">{{
                                ds.Price?.BoardPrice | toToman | number : '2.' }}</span>
                            <div *ngIf="ds?.DiscountBalloon?.Discount &&
                  +ds.DiscountBalloon.Discount! >= 5" class="badge-precent  px-3 py-1 rounded-lg"
                                [ngClass]="accommodation != 'ecolodge' ? 'bg-green-50' : 'bg-[#FFECEC]'">
                                <span class="text-sm  !font-medium"
                                    [ngClass]="accommodation != 'ecolodge' ? 'text-green-800' : 'text-[#FF4242]'">{{
                                    ds?.DiscountBalloon?.Discount }}%</span>
                            </div>
                        </div>

                        <div *ngIf="ds.Price.IhoPrice" class="flex w-full items-center gap-1 justify-end">
                            <span class="text-xs text-muted">{{
                                ds?.Price?.StartingText
                                }}</span>
                            <span class="text-black-500 text-xl font-bold">{{
                                ds?.Price?.IhoPrice | toToman | number : '2.'
                                }}</span>
                            <span class="text-xs text-muted">تومان</span>
                        </div>

                        <button mat-flat-button color="primary" *ngIf="accommodation != 'ecolodge'"
                            (click)="navigateToPDP(ds.HotelUrl, $event)"
                            class="!hidden md:!flex items-center justify-center w-full text-base !h-11 text-white font-semibold">
                            <span *ngIf="true; else onlineHotelButton">انتخاب اتاق و رزرو</span>

                            <ng-template #onlineHotelButton>
                                <p class="flex gap-2 items-center">
                                    <i class="ico-Flash text-2xl text-white"></i>
                                    <span class="text-base text-white whitespace-nowrap">انتخاب اتاق</span>
                                </p>
                            </ng-template>
                        </button>
                    </ng-container>

                    <ng-template #fullCapacityBtn>
                        <div *ngIf="ds.Price?.OldPrice && ds.Price.IhoPrice"
                            class="flex w-full items-center justify-end gap-2">
                            <span
                                class="price-off mx-2 after:content-[''] text-black-200 line-through-price text-xs !font-normal">{{
                                ds.Price?.BoardPrice | toToman | number : '2.' }}</span>
                            <div class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                                <span class="text-sm text-green-800 !font-medium">{{ ds?.DiscountBalloon?.Discount
                                    }}%</span>
                            </div>
                        </div>

                        <div class="flex w-full items-center gap-1 justify-end">
                            <span class="text-xs text-muted">{{
                                ds?.Price?.StartingText
                                }}</span>
                            <span class="text-black-500 text-xl font-bold">{{
                                ds?.Price?.IhoPrice | toToman | number : '2.'
                                }}</span>
                            <span class="text-xs text-muted">تومان</span>
                        </div>

                        <button mat-stroked-button color="warn"
                            class="flex icon-button w-full !h-11 items-center justify-center font-semibold gap-2 text-red-500">
                            <i class="ico-LeftOver text-2xl text-red-500"></i>
                            <span class="text-base text-red-500">تکمیل ظرفیت</span>
                        </button>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- Last vote section(comment)  class comment-accordion-wrapper -->
        <ng-container *ngIf="accommodation != 'ecolodge'">

            <div *ngIf="dataSource?.Comment"
                class="md:flex items-center hidden p-4 bottom-corners-radius bg-white overflow-hidden h-[4.5rem] comment-accordion-wrapper"
                [class.pointer-events-none]="!commentIsLongEnough" (click)="toggleCommentAccordion()" #commentAccordion>
                <div class="flex flex-col items-start gap-1 md:min-w-[220px] lg:min-w-[235px]"
                    style="border-left: 1px solid var(--border-color)">
                    <h6 class="text-sm font-semibold text-black">
                        {{ dataSource.LastVote.GuestName }}
                    </h6>
                    <span class="text-xs text-muted">{{
                        dataSource.LastVote.TravelTypeTitle
                        }}</span>
                </div>

                <div class="flex gap-2 items-start relative self-start cursor-pointer w-full" #accordionBody>
                    <p class="text-sm text-black pr-4 comment-accordion-body w-full"
                        [class.mt-3]="!commentIsLongEnough">
                        {{ dataSource.LastVote.Description }}
                    </p>

                    <i class="ico-Down text-2xl transition-all" *ngIf="commentIsLongEnough"></i>
                </div>
            </div>
        </ng-container>

    </article>
</ng-container>